import {
    DOB_SET_VALUE,
    EMPLOYMENT_DATE_SET_VALUE,
    FIRST_NAME_SET_VALUE,
    ID_PASSPORT_SET_VALUE,
    TIN_NUMBER_SET_VALUE,
    MOBILE_NUMBER_SET_VALUE,
    setDoBValid,
    setEmployementDateValid,
    setFirstNameValid,
    setIdPassortNumberValid,
    setTinNumberValid,
    setMobileNumberValid,
    setSurnameValid,
    SURNAME_SET_VALUE,
} from '../../../actions/travelUg/employeeDetails';
import { validationIsEqual } from '../status';
import {
    validateName,
    validateContactNumber,
    validateDateOfBirth,
    validateDate,
    validatePassportNumber,
    validateSurname,
    validateNumericString,
} from '@om/validation';

let prevValidationAction = null;

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const employeeDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case FIRST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'First Name',
                    min: 2,
                    max: 48,
                });
                return setFirstNameValid(error);

            case TIN_NUMBER_SET_VALUE:
                error = validateNumericString(action.value, { subject: 'TIN', min: 10, max: 10 });
                return setTinNumberValid(error);

            case MOBILE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Mobile Number',
                    countryCode: gatsbyStack,
                });

                return setMobileNumberValid(error);

            case SURNAME_SET_VALUE:
                error = validateSurname(action.value, {
                    subject: 'Surname',
                    min: 2,
                    max: 48,
                });
                return setSurnameValid(error);

            case DOB_SET_VALUE:
                error = validateDateOfBirth(action.value, {
                    subject: 'Date of birth',
                    max: 65,
                    min: 18,
                });
                return setDoBValid(error);

            case EMPLOYMENT_DATE_SET_VALUE:
                error = validateDate(action.value, { subject: 'Date of employment' });
                return setEmployementDateValid(error);

            case ID_PASSPORT_SET_VALUE:
                const error1 = validateNumericString(action.value, {
                    min: 8,
                    max: 15,
                    subject: 'ID number',
                    required: true,
                });
                const error2 = validatePassportNumber(action.value, { subject: 'Passport number', required: true });
                error = !error1 && !error2 ? null : !error2 ? null : error1;
                return setIdPassortNumberValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
